import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '../material.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MyDiaryComponent } from './my-diary/my-diary.component';
// import { MyPipesModule } from '../common/order-by.pipe';
import { MyPendingSubmissionComponent } from './my-pending-submission/my-pending-submission.component';
import { MyPendingApprovalComponent } from './my-pending-approval/my-pending-approval.component';
import { MyPipesModule } from '../common/my-pipes.module';
import { ResendDialogComponent } from './resend-dialog/resend-dialog.component';
import { DiaryRedendDialgComponent } from './diary-redend-dialg/diary-redend-dialg.component';
import { MyUnapprovedDiariesComponent } from './my-unapproved-diaries/my-unapproved-diaries.component';

@NgModule({
  declarations: [MyDiaryComponent, MyPendingSubmissionComponent, MyPendingApprovalComponent,
    ResendDialogComponent,
    DiaryRedendDialgComponent, MyUnapprovedDiariesComponent],
  imports: [
    CommonModule,
    MaterialModule,
    NgbModule,
    FormsModule,
    ReactiveFormsModule,
    MyPipesModule
  ],
  entryComponents: [ResendDialogComponent]
})
export class ManageDiaryModule { }
